module.exports = __webpack_public_path__ + "img/siren-on.97c21aa5.svg";